import "./Validation.scss";
import { useEffect, useState, useContext } from "react";
import {
  Col,
  Row,
  Checkbox,
  Button,
  Form,
  Select,
  Input
} from "antd";

import { useTranslation } from "react-i18next";
import { globalContext } from "../../../../../../contexts";

const Validation = ({ fields, field, handleClickSelect, closeModalHandler, lang }) => {
	const { t } = useTranslation(['forms','translations'])
	const { datasources, currentUser } = useContext(globalContext)
    const [ visible, setVisible ] = useState(field.visibility?.visible?? true)
    const [ fieldId, setFieldId ] = useState(field.visibility?.fieldId?? null)
    const [ fieldVisible, setFieldVisible ] = useState(null)
    const [ fieldValue, setFieldValue ] = useState(field.visibility?.fieldValue?? null)

    useEffect(() => {
        if(field.visibility?.fieldId) {
            handleChangeField(field.visibility.fieldId, false)
        }
    }, [])

    const handleChangeVisible = (checked) => {
        setVisible(checked)
    }

    const handleClickSelectVisible = () => {
        handleClickSelect({ visible, fieldId, fieldValue })
    }

    const handleChangeField = (id, resetValue) => {
        setFieldId(id)
        const f = fields.filter(f => f.id === id)
        setFieldVisible(f[0])
        if(resetValue) setFieldValue(undefined)
    }

    const handleChangeValue = (val) => {
        setFieldValue(val)
    }

    const getValuesFromDS = (field) => {
        if(datasources && field.source && field.source.indexOf(':') > 0) {
            let ds = field.source.split(':')
            if(datasources[ds[0]] && datasources[ds[0]][ds[1]]) {
                let datasource = datasources[ds[0]][ds[1]] 
                if(datasource.parent) {
                    if(datasources[ds[0]][datasource.parent]) {
                        const values = datasources[ds[0]][datasource.parent].values
                        if(datasource.parent === "COUNTRIES") {
                            let countryCode = ""
                            if(currentUser?.cliente) {
                                countryCode = currentUser.cliente.pais === "CHI" ? "CL" : currentUser.cliente.pais === "PER" ? "PE" : ""
                            }
                            const parValue = values.find(v => v.code === countryCode)
                            return datasource.values.filter(v => v.parent == parValue?.code)
                        }
                    }
                }
                return datasource.values
            }
        }
        return [{code: 'no-data', value: {es: "No hay datos", en: "No data", pt: "No dados"}}]
    }

    return (
        <Row className="validation-edit">
            <Row gutter={[0,50]}>
                <Col span={6}>
                    {t('messages.aml.always', {ns: 'translations'})}
                </Col>
                <Col span={18}>
                    <Checkbox checked={visible} onChange={(e) => handleChangeVisible(e.target.checked)}/>
                </Col>
            </Row>
            <Row>
                <Col span={12}>
                    <Form.Item label={t('forms.manager.validation.attributeName')}>
                        <Select 
                            allowClear
                            disabled={visible} 
                            value={!visible && fieldId} 
                            onChange={(val) => handleChangeField(val, true)}
                        >
                            {fields && fields.map(f =>
                                ["SELECT","RADIO","CHECKBOX","RADIOOTHER"].includes(f.typeField) && f.id !== field.id && <Select.Option value={f.id}>{f.title && f.title[lang]}</Select.Option>
                            )}
                        </Select>
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item label={t('forms.manager.validation.option')}>
                        { fieldVisible ?
                            (
                                fieldVisible.typeField === "CHECKBOX" ?
                                    <Checkbox disabled={visible} checked={!visible && fieldValue} onChange={(e) => handleChangeValue(e.target.checked)}/>
                                : fieldVisible.source &&
                                    <Select
                                        showSearch
                                        allowClear
                                        mode="multiple"
                                        disabled={visible}
                                        filterOption={(input, option) =>
                                            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        }
                                        value={!visible && fieldValue}
                                        onChange={handleChangeValue} 
                                    >
                                        { getValuesFromDS(fieldVisible).map(val =>
                                            <Select.Option value={val.code}>{val.jsonValue && val.jsonValue[lang]}</Select.Option>
                                        )}
                                    </Select>
                            )
                            :
                            <Input disabled={true} />
                        }
                    </Form.Item>
                </Col>
            </Row>

            <Row className="tools-validation">
                    <Button onClick={closeModalHandler}>{t('forms.manager.validation.close')}</Button>
                    <Button type="primary" onClick={handleClickSelectVisible}>{t('forms.manager.validation.apply')}</Button>
            </Row>
        </Row>
    )
}
export default Validation;